import React from 'react';
import bn from '../utils/bemnames';
import {IDropdownItem} from '../utils/types';
import { _t } from '../utils/translations';

const bem = bn.create('filter-dropdown');

interface IProps {
  dropdownList: IDropdownItem[]|null;
  selectedItem: IDropdownItem|null;
  onStateChange: ((value: IDropdownItem|null) => void);
  withDefault?: boolean;
}

interface IState {
  dropdownList: IDropdownItem[],
  showDropdownList: boolean,
  selectedItem: IDropdownItem|null,
  withDefault: boolean
}

class FilterDropdown extends React.Component<IProps> {

  public readonly state: IState = {
    showDropdownList: false,
    selectedItem: null,
    dropdownList: [],
    withDefault: false
  };

  componentDidMount() {
    this.setState({
      dropdownList: this.props.dropdownList,
      selectedItem: this.props.selectedItem,
      withDefault: this.props.withDefault
    });
  }

  componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<{}>, snapshot?: any) {
    if(prevProps.selectedItem !== this.props.selectedItem) {
      this.setState({
        selectedItem: this.props.selectedItem
      });
    }
  }

  toggleDropdownList() {
    this.setState({
      showDropdownList: !this.state.showDropdownList
    });
  }

  setItem = (listItem: IDropdownItem|null) => {
    this.setState({
      selectedItem: listItem,
      showDropdownList: false,
    });
    this.props.onStateChange(listItem);
  }

  render() {
    const { showDropdownList, dropdownList, selectedItem, withDefault } = this.state;
    return (
      <>
        <div className={bem.e('wrapper')}>
          <div onClick={() => this.toggleDropdownList()} className={bem.e('header')}>
            <span className={bem.e('header-title')}>{selectedItem ? selectedItem.name : _t('All')}</span>
            <span className={showDropdownList ? bem.e('filter-live-arrow') + ' ' + bem.e('filter-live-arrow-active') : bem.e('filter-live-arrow')} />
          </div>
          <div className={bem.e('list-wrapper')}>
            {showDropdownList && (<ul className={bem.e('list')}>
              {!withDefault && (
                <li className={bem.e('list-item')} key={null}>
                  <button onClick={() => this.setItem(null)}>{_t('All')}</button>
                </li>
              )}
              {dropdownList.map((listItem) => {
                return (
                  <li className={bem.e('list-item')} key={listItem.value}>
                    <button onClick={() => this.setItem(listItem)}>{listItem.name}</button>
                  </li>
                );
              })}
            </ul>)}
          </div>
        </div>
      </>
    );
  }
}

export default FilterDropdown;
